// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"092119f9","421":"33023c8f","471":"e8efd769","739":"b74305fe","933":"8445e211"}[chunkId] + ".chunk.js";
};